import { render, staticRenderFns } from "./crearVendedoresModal.vue?vue&type=template&id=2881dd76"
import script from "./crearVendedoresModal.vue?vue&type=script&lang=js"
export * from "./crearVendedoresModal.vue?vue&type=script&lang=js"
import style0 from "./crearVendedoresModal.vue?vue&type=style&index=0&id=2881dd76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports